import {
  FETCH_STONETYPE_REQUEST,
  FETCH_STONETYPE_SUCCESS,
  FETCH_STONETYPE_FAILURE,
  ADD_STONETYPE_REQUEST,
  ADD_STONETYPE_SUCCESS,
  ADD_STONETYPE_FAILURE,
  UPDATE_STONETYPE_REQUEST,
  UPDATE_STONETYPE_SUCCESS,
  UPDATE_STONETYPE_FAILURE,
  DELETE_STONETYPE_REQUEST,
  DELETE_STONETYPE_SUCCESS,
  DELETE_STONETYPE_FAILURE,
  STONETYPE_FORM_ERROR,
  STONETYPE_FORM_SUCCESS,
  SET_STONETYPE_EDIT,
  CLEAR_STONETYPE_EDIT,
} from '../../../../types/masters/stoneAttribute/stoneType/stoneTypeTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingStoneType: null,
};

const stoneTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STONETYPE_REQUEST:
    case ADD_STONETYPE_REQUEST:
    case UPDATE_STONETYPE_REQUEST:
    case DELETE_STONETYPE_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_STONETYPE_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_STONETYPE_SUCCESS:
    case UPDATE_STONETYPE_SUCCESS:
    case DELETE_STONETYPE_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_STONETYPE_FAILURE:
    case ADD_STONETYPE_FAILURE:
    case UPDATE_STONETYPE_FAILURE:
    case DELETE_STONETYPE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_STONETYPE_EDIT:
      return { ...state, editingStoneType: action.payload };
    case CLEAR_STONETYPE_EDIT:
      return { ...state, editingStoneType: null };
    default:
      return state;
  }
};

export default stoneTypeReducer; 